import { UntypedFormBuilder, Validators } from "@angular/forms";
import { EmployeeCompany } from "./EmployeeCompany";

export interface Employee {
    id: number;
    name: string;
    surname: string;
    position: string;
    supervisorEmployeeId?: number;
    hasInspectionRoleAllowed?: boolean;
    hasTechnicianRoleAllowed?: boolean;
    hasAssemblyRoleAllowed?: boolean;
    hasEmployeeTechnicianAllowed?: boolean;
    hasEmployeeMeritoricAllowed?: boolean;
    hasEmployeeExpertTechnicianAllowed?: boolean;
    hasEmployeeExpertMeritoricAllowed?: boolean;
    hasPartsHandlingEmployeeAllowed?: boolean;
    isInternalEmployee?: boolean;
    agreementTypeId?: number;

    createdBy?: string;
    timestamp?: string;

    provisionStandardInspection?:string;
    provisionAdditionalInspection?:string;
    provisionPdrRepairInsuranceCompany?: string | null;
    provisionPdrRepairPartnerService?: string | null;
    provisionPdrRepairFleet?: string | null;
    provisionPdrRepairPrivate?: string | null;
    provisionAssemblyInsuranceCompany?: string | null;
    provisionAssemblyPartnerService?: string | null;
    provisionAssemblyFleet?: string | null;
    provisionAssemblyPrivate?: string | null;
    provisionDisassemblyInsuranceCompany?: string | null;
    provisionDisassemblyPartnerService?: string | null;
    provisionDisassemblyFleet?: string | null;
    provisionDisassemblyPrivate?: string | null;
    provisionCarWashingBeforeRepair?: string | null;
    provisionCarWashingAfterRepair?: string | null;

    provisionExchangesInsuranceCompany?: string | null;
    provisionExchangesPartnerService?: string | null;
    provisionExchangesFleet?: string | null;
    provisionExchangesPrivate?: string | null;

    employeeCompanyId? : number;
    employeeCompany? : EmployeeCompany;
    additionalInfo?: string;
}


export class EmployeeFormBuilder {

    static getForm(fb: UntypedFormBuilder, employee: Employee) {

        return fb.group(
            {
                id: [employee.id],
                name: [employee.name, [Validators.required]],
                surname: [employee.surname, [Validators.required]],
                position: [employee.position, [Validators.required]],
                supervisorEmployeeId: [employee.supervisorEmployeeId],
                hasInspectionRoleAllowed: [employee.hasInspectionRoleAllowed],
                hasTechnicianRoleAllowed: [employee.hasTechnicianRoleAllowed],
                hasAssemblyRoleAllowed: [employee.hasAssemblyRoleAllowed],
                hasEmployeeTechnicianAllowed: [employee.hasEmployeeTechnicianAllowed],
                hasEmployeeMeritoricAllowed: [employee.hasEmployeeMeritoricAllowed],
                hasEmployeeExpertTechnicianAllowed: [employee.hasEmployeeExpertTechnicianAllowed],
                hasEmployeeExpertMeritoricAllowed: [employee.hasEmployeeExpertMeritoricAllowed],
                hasPartsHandlingEmployeeAllowed: [employee.hasPartsHandlingEmployeeAllowed],
                isInternalEmployee: [employee.isInternalEmployee],
                agreementTypeId: [employee.agreementTypeId],
                additionalInfo: [employee.additionalInfo],
            }
        );
    }

    static initEmployee(): Employee {

        return {
            id: 0,
            name: '',
            surname: '',
            position: '',
            createdBy:'',
            supervisorEmployeeId:null,
            hasInspectionRoleAllowed: false,
            hasTechnicianRoleAllowed: false,
            hasAssemblyRoleAllowed:false,
            hasEmployeeTechnicianAllowed: false,
            hasEmployeeMeritoricAllowed:false,
            hasEmployeeExpertTechnicianAllowed:false,
            hasEmployeeExpertMeritoricAllowed:false,
            isInternalEmployee: false,
            hasPartsHandlingEmployeeAllowed: false,
            additionalInfo: ''

        };
    }
}


